module.exports = __webpack_public_path__ + "static/media/IMG_20161024_215112_edited.ae58c02c.jpg";